import { render, staticRenderFns } from "./SaleAIInsight.vue?vue&type=template&id=dea8151e"
import script from "./SaleAIInsight.vue?vue&type=script&lang=js"
export * from "./SaleAIInsight.vue?vue&type=script&lang=js"
import style0 from "./SaleAIInsight.vue?vue&type=style&index=0&id=dea8151e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports